import React, { useState } from 'react'
import date from 'date-and-time'
import Button from '../../../../../../../Components/Buttons/Button'
import Accordion from '../../../../../../../Components/Accordion/Accordion'
import { getBatchLayoutData } from '../../../../../../Dashboard/Components/Courses/Components/GroupCourseBatches/Helper'
import useTime from '../../../../../../../Helpers/CustomHooks/useTime'
import Modal from '../../../../../../../Components/Modal/Modal'
import VideoRecord from '../../../../../../../Modules/videoRecord'
import { VideoRecordModalEl } from '../Elements'
import { H5 } from '../../../../../../../Styles/typography'

const Batch = ({
  index,
  title,
  slots,
  enroll,
  setSuccess,
  id,
  setSelBatch,
}) => {
  const now = useTime(5000)
  const [showModal, toggleModal] = useState(false)
  const [{ data, days }] = useState(getBatchLayoutData(slots))

  const startTime = slots.sort((a, b) => a.startTime - b.startTime)[0].startTime
  const endTime = slots.sort((a, b) => a.startTime - b.startTime).slice(-1)[0]
    .endTime

  return now > endTime ? null : (
    <div className='batch'>
      <div className='info'>
        <p className='batchName'>{title}</p>
        <Button
          onClick={() => {
            setSelBatch(index)
            // toggleModal(true);
            // setPending(true);
            // const success = await enroll("Requesting enrollment", id);
            // setPending(false);
            // if (success) {
            //   setSuccess(true);
            // }
          }}
          name={'Register'}
          type={'primary'}
        />
      </div>
      <p className='starts'>
        Starts on{' '}
        {date
          .format(new Date(startTime), `DD MMM YY, hh:mm A`)
          .split('.')
          .join('')}
      </p>
      <p className='ends'>
        Ends on{' '}
        {date
          .format(new Date(endTime), `DD MMM YY, hh:mm A`)
          .split('.')
          .join('')}
      </p>
      <Accordion
        trigger={
          <p className={'slotsOverview'}>
            {days.length} days/week on ({days.map(({ day }) => day).join(', ')})
            <span className='view'>View all slots</span>
            <span className='hide'>Hide slots</span>
          </p>
        }
      >
        <div className='slots'>
          <div className='header'>
            <p className='weekName' />
            {days.map(({ index: i, day }) => (
              <p key={`batch-${index}-day-header-${i}`}>{day.slice(0, 3)}</p>
            ))}
          </div>
          {Object.entries(data).map(([week, allottedDays], i) => (
            <div className='row' key={`batch-${index}-week-${i}`}>
              <p className='weekName'>Week {i + 1}</p>
              {days.map(({ index: day }, j) => (
                <p key={`batch-${index}-week-${i}-day-${j}`}>
                  {(allottedDays[day] || []).map(
                    ({ startTime, endTime }, k) => (
                      <span key={`batch-${index}-week-${i}-day-${j}-slot-${k}`}>
                        {date.format(new Date(startTime), 'DD MMM YYYY')} <br />
                        {date
                          .format(new Date(startTime), 'hh:mm A - ')
                          .split('.')
                          .join('')
                          .toUpperCase()}
                        {date
                          .format(new Date(endTime), 'hh:mm A')
                          .split('.')
                          .join('')
                          .toUpperCase()}
                      </span>
                    ),
                  )}
                </p>
              ))}
            </div>
          ))}
        </div>
      </Accordion>
      {showModal && (
        <Modal close={() => toggleModal(false)}>
          <VideoRecordModalEl>
            <H5>
              To register for this course, you need to submit an audition video
              of yourself. <br /> Please record and submit your audition video.
            </H5>
            <div className='video-container'>
              <VideoRecord
                submit={async (message, videoURL) => {
                  window.localStorage.setItem('auditionVideo', videoURL)
                  const success = await enroll(message, id)
                  toggleModal(false)
                  if (success) {
                    setSuccess(true)
                  }
                }}
              />
            </div>
          </VideoRecordModalEl>
        </Modal>
      )}
    </div>
  )
}

export default Batch
